module.exports = __webpack_public_path__ + "assets/img/map-small.9c6d585f.jpg";